import React from 'react';
import PropTypes from 'prop-types';
import { FormikInput } from 'components/UiKit/FormikFields';
import PersonFieldLabel from '../PersonFieldLabel';

function StreetAddressField({
  title = '',
  name = '',
  blockMargin = '',
  id = 'id'
}) {
  return (
    <div className="my-4 w-full">
      <div className={`block ${blockMargin}`}>
        <div className="w-full">
          <PersonFieldLabel htmlFor={id}>{title}</PersonFieldLabel>
        </div>
        <div className="w-full">
          <FormikInput id={id} name={name} />
        </div>
      </div>
    </div>
  );
}

StreetAddressField.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  blockMargin: PropTypes.string,
  id: PropTypes.string
};

export default StreetAddressField;
